import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from '../taskMessages';
import DataCacheService from '@/shared/services/DataCacheService';
import FormattedListValue, { listItemMsg } from '@/shared/components/FormattedListValue';
import TaskStatusIcon from '../TaskStatusIcon';
import FormattedDateTime from '@/shared/components/FormattedDateTime';
import TaskDetailsHistoryLog from './TaskDetailsHistoryLog';

const getUsername = (userId, intl) => {
  const user = DataCacheService.getUserName(userId);
  return user || intl.formatMessage(messages.System);
};

const renderSource = (userId, source, intl) => {
  if (!source || source === 1) {
    //Manual
    return <span className="name">{getUsername(userId, intl)}</span>;
  }
  if (source === 3) {
    //Taskplanning
    return intl.formatMessage(listItemMsg('TaskStatusUpdateSource', source)).toLowerCase();
  }

  return (
    <>
      <span className="name">{getUsername(userId, intl)}</span>
      &nbsp;
      {intl.formatMessage(messages.Via).toLowerCase()}
      &nbsp;
      <FormattedListValue list="TaskStatusUpdateSource" id={source} />
    </>
  );
};
const TaskDetailsHistory = ({ taskStatusHistory, onHideHistory, taskLevel, intl }) => {
  return (
    <div className="task-detail-section history">
      <a className="btn btn-default btn-xs pull-right show-history-btn" onClick={onHideHistory}>
        <i className="fa fa-history margin5R" />
        <span>{intl.formatMessage(messages.HideHistory)}</span>
      </a>
      <h5 className="visible-lg-inline-block">
        <i className="fa fa-history fa margin5R" aria-hidden="true" />
        {intl.formatMessage(messages.History)}
      </h5>

      <table>
        <tbody>
          {taskStatusHistory.map(historyItem => (
            <tr key={historyItem.timestamp}>
              <td className="log">
                <TaskDetailsHistoryLog value={historyItem} taskLevel={taskLevel} intl={intl} />
              </td>
              <td>
                <FormattedDateTime value={historyItem.timestamp} />
                &nbsp;
                {renderSource(historyItem.userId, historyItem.source, intl)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

TaskDetailsHistory.propTypes = {
  taskStatusHistory: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.number,
    }),
  ).isRequired,
  intl: intlShape.isRequired,
  onHideHistory: PropTypes.func.isRequired,
};

export default injectIntl(TaskDetailsHistory);
